import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import dummyImage from "../../Assets/Group 1171283252[1].png"; //fallback image
import { ArrowDown } from '../Icons';
import getTranslationData from '../../TranslationUtility/TranslationUtility';
import SelectWidgetCardModel from './SelectWidgetCardModel';
import { getclientConfigDataAsync } from '../../Store/Slices/clientConfigDataSlice';
import { trackEvent, useGaTrackingConfig } from '../Utility/Utility';

const RewardWidget = ({ ...props }) => {
    const clientInfo = useSelector((state) => state.clientDataReducer);
    const [selectedCard, setSelectedCard] = useState({});
    const [showCardSection, setShowCardSection] = useState(false);
    const [cardList, setCrdList] = useState([]);
    const translation = getTranslationData();
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const dispatch = useDispatch();
    const cardListData = useSelector((state) => state.clientConfigDataReducer);
    const gaTrackingConfig = useGaTrackingConfig();

    const confirmCardData = (cards) => {
        let sortedActiveCards = [...cards]?.sort((a, b) => a?.displayOrder - b?.displayOrder).filter((card) => card?.isActive);
        let selectdRewardWidget = localStorage.getItem("RewardWidget");
        let selectedCardData = [];
        const setDefaultCard = (defaultCard) => {
            if (defaultCard) {
                selectedCardData = defaultCard;
            }
            else {
                selectedCardData = sortedActiveCards[0];
            }
        }
        if (selectdRewardWidget !== 'undefined' && selectdRewardWidget !== null) {
            selectedCardData = sortedActiveCards?.find(card => card.cardId === selectdRewardWidget);
            if (!selectedCardData) {
                setDefaultCard(selectedCardData);
            }
        }
        else {
            let defaultCard = sortedActiveCards?.find(card => card?.isDefault === true);
            setDefaultCard(defaultCard);
        }
        localStorage.setItem("RewardWidget", selectedCardData?.cardId);
        sortedActiveCards = sortedActiveCards.map((card) => { return card?.cardId === selectedCardData?.cardId ? { ...card, isSelected: true } : { ...card, isSelected: false } })
        setCrdList(sortedActiveCards);
        setSelectedCard(selectedCardData);
        setShowCardSection(true);
    }

    useEffect(() => {
        if (clientInfo) {
            const cardSectionConfig = clientInfo?.clientData?.clientConfigurations?.find((config) => config.configKey === "isrewardwidgete")
            if (cardSectionConfig && cardSectionConfig?.configValue === "1") {
                (async () => {
                    if (cardListData?.clientConfigData?.cards?.length > 0) {
                        confirmCardData(cardListData?.clientConfigData?.cards);
                    }
                    else {
                        await dispatch(getclientConfigDataAsync("widgetdata")).then((res) => {
                            const { cards } = res?.payload?.response || [];
                            if (cards?.length > 0) {
                                confirmCardData(cards);
                            }
                        }).catch((err) => {
                            console.error("Error fetching card list:", err);
                            return { cards: [] };
                        });
                    }
                })();
            }
            else {
                setShowCardSection(false);
                setCrdList([]);
            }
        }
    }, [clientInfo])

    const cardSelectHandle = (selectedCard, ind) => {
        setSelectedCard(selectedCard);
        localStorage.setItem("RewardWidget", selectedCard?.cardId);
        let updatedCardList = cardList.map((card) => { return card?.cardId === selectedCard?.cardId ? { ...selectedCard, isSelected: true } : { ...card, isSelected: false } })
        setCrdList(updatedCardList);
        toggleWidgetSelect();
        const rewardPoints = Math.round((props.totalAmount / selectedCard.perRs) *
            selectedCard.standardPoints *
            ((selectedCard.bonusPoints / selectedCard.standardPoints) + 1))
        trackEvent("select_bank_card", {
            page_type: window.location.href.includes("/card?") ? "checkout_page"
                : "product_page",
            client_code: gaTrackingConfig.trackingContext.client_code,
            platform_code: gaTrackingConfig.trackingContext.platform_code,
            card_name: selectedCard?.cardName ? selectedCard?.cardName : "NA",
            reward_points: rewardPoints,
            page_url: window.location.href,
            // page_title: window.location.href.includes('/giftcard') ? "pdp" : "checkout_page",
        });
    }
    const handleImageError = (e) => {
        e.target.onerror = null; // Prevent infinite loop if fallback fails
        e.target.src = dummyImage; // Set fallback
    };

    const toggleWidgetSelect = () => setShowModal(!showModal);
    return (

        <>
            {/* mobile view card section  */}
            {
                showCardSection &&
                <div className={`container cardBox rounded-4 mb-3 ${props?.className ? ` ${props?.className}` : ""} ${props.stockOutDenominations ? "disabled-comp" : ""}`}>
                    <div className="cardBox-title">{translation?.calculate_reward_points_on}</div>
                    <div className="cardBox-card rounded-3 mt-1 d-flex align-items-center"
                        onClick={toggleWidgetSelect}
                    >
                        <img src={`${process.env.REACT_APP_CLIENT_URL}${selectedCard?.cardThumbnailUrl}`} onError={handleImageError} alt={selectedCard?.cardName || ""}></img >
                        <div className="truncate px-3 bold flex-grow-1">{translation?.american_express} {selectedCard?.cardName} </div>
                        <div className="ml-auto cursor-pointer"> <ArrowDown ></ArrowDown></div>
                    </div>
                    <div className="mt-3 two-four-border cardBox-points d-flex justify-content-center align-item-center flex-column">
                        <div style={{ fontSize: '14px' }}>{translation.you_will_earn_label}</div>
                        <div className="fw-bold" style={{ fontSize: '20px' }}>
                            {Math.round((props.totalAmount / selectedCard.perRs) *
                                selectedCard.standardPoints *
                                ((selectedCard.bonusPoints / selectedCard.standardPoints) + 1)).toLocaleString()
                                || 0} {" "} {translation.reward_points}
                        </div>
                    </div>
                    <div className='widget-points-limit'>
                        <p>{translation?.widget_reward_points_limit_txt}</p>
                        <p className='subHeading'>{translation?.points_credited_successful_transaction}</p>
                    </div>
                </div>
            }
            <div className="container">
                {showModal && (
                    <SelectWidgetCardModel
                        // modalDataValue={modalData}
                        show={showModal}
                        modalClass={""}
                        handleClose={handleClose}
                        cardList={cardList}
                        cardSelectHandle={cardSelectHandle}
                    />
                )}
            </div>
        </>
    )
}

export default RewardWidget
